
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.126","height":"16.127"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.626 8.414v-.7a1.193 1.193 0 00-1.193-1.193h0a1.1 1.1 0 01-.774-1.869h0a1.193 1.193 0 000-1.687l-.5-.5a1.194 1.194 0 00-1.687 0h0a1.094 1.094 0 01-1.869-.774h0A1.193 1.193 0 008.41.498h-.7a1.193 1.193 0 00-1.193 1.193h0a1.1 1.1 0 01-1.869.774h0a1.194 1.194 0 00-1.687 0l-.5.5a1.192 1.192 0 000 1.687h0a1.1 1.1 0 01-.775 1.869h0A1.193 1.193 0 00.493 7.714v.7a1.193 1.193 0 001.193 1.193h0a1.1 1.1 0 01.774 1.869h0a1.193 1.193 0 000 1.687l.5.5a1.194 1.194 0 001.687 0h0a1.1 1.1 0 011.869.774h0a1.193 1.193 0 001.193 1.193h.7a1.193 1.193 0 001.193-1.193h0a1.094 1.094 0 011.869-.774h0a1.193 1.193 0 001.687 0l.5-.5a1.193 1.193 0 000-1.687h0a1.1 1.1 0 01.774-1.869h0a1.193 1.193 0 001.194-1.193z","fill":"none","stroke":"#f1f1f3","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10.447 7.783a2.384 2.384 0 11-2.384-2.384 2.383 2.383 0 012.384 2.384z","fill":"none","stroke":"#f1f1f3","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    